import { STORE_EXCHANGE } from "@app/constants/LOCALKEYS";
import useSWR from "swr";
import { getPersistData } from "../persist";
import { useToken } from "../auth/token";
import API from "../../../utils/api";
import { useMemo, useCallback } from "react";
import useThrottle from "@utils/useThrottle.ts";

const KEY = STORE_EXCHANGE;

let swrData: any = getPersistData(KEY);

export function useExchangeStore(initData?: any, reset?: boolean) {
  const { data: token, getLatestToken } = useToken();

  const { data, mutate: swrMutate } = useSWR<any>(
    KEY,
    async () => {
      if (reset) {
        swrData = null;
        return null;
      }
      // if (!token) return initData || swrData;

      const currentToken = getLatestToken();
      const result = await API.get("/exchanges?id=1", currentToken + "", {}, false);
      swrData = result.result;
      return swrData;
    },
    {
      dedupingInterval: 1000 * 60 * 30, // 30분간 동일한 요청 방지
      fallbackData: initData || swrData, // 초기 데이터 제공
      revalidateOnFocus: false, // 포커스 시 재검증 방지
      revalidateOnReconnect: false, // 재연결 시 재검증 방지
    }
  );

  // 조건부로 필터링된 EPs 계산 (ID 10번 이오스 제외)
  const EPs = useMemo(
    // () => (data?.length > 0 ? data.filter(() => true) : []),
    () => (data?.length > 0 ? data.filter((item: any) => item.id !== 10) : []),
    [data]
  );

  // Throttled mutate 함수
  const throttledMutate = useThrottle(
    useCallback(
      (value?: any) => {
        if (value !== undefined) swrMutate(value, false); // 재검증 없이 업데이트
        else swrMutate();
      },
      [swrMutate]
    ),
    500 // 0.5초에 한 번만 실행
  );

  return {
    data,
    EPs,
    mutate: throttledMutate,
  };
}
